import React from 'react'
import Icon from '../icon'
import { StepsContainer, DashedLine, Step } from './style'

const STATUS = ['notstarted', 'ongoing', 'done']

function Steps({ currentStep, handleStepNavigation, steps, ...props }) {
  currentStep -= 1

  return (
    <StepsContainer style={{ flexDirection: 'row', display: 'flex' }}>
      {steps.map((step, index) => {
        const status = index === currentStep ? STATUS[1] : index < currentStep ? STATUS[2] : STATUS[0]
        return (
          <Step
            status={status}
            key={index}
            onClick={() => {
              handleStepNavigation(index)
            }}
            {...props}
          >
            {currentStep > index ? <Icon name='ok' /> : index + 1}
            <label>{step}</label>
          </Step>
        )
      })}
      <DashedLine />
    </StepsContainer>
  )
}

export default Steps
